const WeekComparator = (
    valueA: string | null,
    valueB: string | null
): number => {
    if (!valueA && !valueB) {
        return 0;
    }

    if (!valueA) {
        return -1;
    }

    if (!valueB) {
        return 1;
    }

    // Extract week number and year
    const parseWeek = (
        weekStr: string
    ): { week: number; year: number } | null => {
        const match = weekStr.match(/^Wk(\d+) - (\d{2})$/);
        return match
            ? { week: parseInt(match[1], 10), year: parseInt(match[2], 10) }
            : null;
    };

    const parsedA = parseWeek(valueA);
    const parsedB = parseWeek(valueB);

    if (!parsedA || !parsedB) {
        return 0; // If the format is incorrect, consider them equal
    }

    // Compare years first
    if (parsedA.year > parsedB.year) {
        return 1;
    } else if (parsedA.year < parsedB.year) {
        return -1;
    }

    // If years are equal, compare the week numbers
    if (parsedA.week > parsedB.week) {
        return 1;
    } else if (parsedA.week < parsedB.week) {
        return -1;
    }

    return 0;
};

export default WeekComparator;
